import { getReplay } from '@sentry/nextjs';
import { proxy } from 'valtio';

import { SessionStorageService } from 'services/SessionStorageService';

const ImpersonationService = {
    state: proxy({
        impersonating: SessionStorageService.get('impersonate') === true,
    }),

    start: () => {
        SessionStorageService.store('impersonate', true);
        ImpersonationService.state.impersonating = true;

        // Sentry is initialized before the impersonate flag is stored, so stop the running session replay
        try {
            getReplay()?.stop();
        } catch (_) {
            // Ignore errors, we're just trying to stop the replay
        }
    },

    isImpersonating: () => {
        return SessionStorageService.get('impersonate') === true;
    },
};

export { ImpersonationService };
